import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import React from 'react';
import IconHeart from '@/assets/icons/heroIcons/Heart.svg';
import IconTarget from '@/assets/icons/heroIcons/Target.svg';
import IconEducation from '@/assets/icons/heroIcons/Education.svg';
import IconUserGroup from '@/assets/icons/heroIcons/User-group.svg';
import { Link } from '@/components/links';
export function Facts() {
  const $ = _c(47);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["career"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("facts.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-10 px-0 lg:mb-16" variant="inverted" anchorKey="facts.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("facts.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link analyticsParam="ethicalCodex" testId="ethicalCodex" to="/files/cs/Skippay_Eticky_kodex.pdf" target="_blank" />;
    t5 = <Link analyticsParam="criminalActivity" testId="criminalActivity" to="/files/cs/Skippay_Nulova_tolerance_k_trestne_cinnosti.pdf" target="_blank" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = <Trans t={t} i18nKey="facts.items.1.text">{t4}{t5}</Trans>;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconTarget />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t6) {
    t8 = {
      title: t3,
      paragraph: t6,
      icon: t7
    };
    $[12] = t3;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("facts.items.2.title");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("facts.items.2.text");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconHeart />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t9) {
    t12 = {
      title: t9,
      paragraph: t10,
      icon: t11
    };
    $[20] = t10;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t("facts.items.3.title");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t("facts.items.3.text");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconEducation />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t13 || $[29] !== t14) {
    t16 = {
      title: t13,
      paragraph: t14,
      icon: t15
    };
    $[28] = t13;
    $[29] = t14;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t) {
    t17 = t("facts.items.4.title");
    $[31] = t;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t) {
    t18 = t("facts.items.4.text");
    $[33] = t;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconUserGroup />;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t17 || $[37] !== t18) {
    t20 = {
      title: t17,
      paragraph: t18,
      icon: t19
    };
    $[36] = t17;
    $[37] = t18;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t12 || $[40] !== t16 || $[41] !== t20 || $[42] !== t8) {
    t21 = <div className="mx-auto max-w-[72rem]"><InfoBoxes items={[t8, t12, t16, t20]} variant="inverted" withCharacters={true} /></div>;
    $[39] = t12;
    $[40] = t16;
    $[41] = t20;
    $[42] = t8;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t2 || $[45] !== t21) {
    t22 = <div className="px-4">{t2}{t21}</div>;
    $[44] = t2;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
}